
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';

export const StyledSlider = withStyles({
  root: {
    color: '#3a8589',
    height: 3,
    padding: '13px 0',
    width: '240px',
    margin: '0 auto',
    display: 'block',
  },
  thumb: {
    height: 15,
    width: 15,
    backgroundColor: '#fff',
    border: '1px solid currentColor',
    marginTop: -5,
    marginLeft: -8,
    boxShadow: '#ebebeb 0px 2px 2px',
    '&:focus,&:hover,&$active': {
      boxShadow: '#ccc 0px 2px 3px 1px',
    },
    '& .bar': {
      // display: inline-block !important;
      height: 9,
      width: 1,
      backgroundColor: 'currentColor',
      marginLeft: 1,
      marginRight: 1,
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% -3px)',
    fontSize: '11px',
  },
  track: {
    height: 5,
  },
  rail: {
    color: '#d8d8d8',
    opacity: 1,
    height: 3,
  },
})(Slider);

export const SliderWrapper = styled.div`
  float: right;
  width: 300px;
  margin-top: -65px;
  padding: 20px;
  border-radius: 10px;
  border: 2px solid #EDEDED;
`;

export const SliderTitle = styled.div`
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 5px;
  margin-top: -10px;
  position: relative;
`;
